import { objectToQueryString } from '../../helpers/objectToQueryString';
import { IGetAllNewsResponse } from '../../types/news';
import { axiosInstance } from '../axiosInstance';

export const getAllNews = async (
  params?: Record<string, string | number>,
): Promise<IGetAllNewsResponse> => {
  const queryString = params ? objectToQueryString(params) : '';

  const response = await axiosInstance.get(`/news?${queryString}`);

  return response.data;
};
